import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { EditLegendContainer } from '../../Legend';
import { LegendItem } from '../../../components/Legend';
import { reqLegend, toggleEditLegend } from '../../../actions/legendActions';
import { trackEvent } from '../../../actions/analyticsActions';
import { getLayerUnits } from '../../../config/legendUnits';
import { IN_SEASON } from '../../../constants/mapLayerIds';
import styles from '../harvestAndPlanting/HarvestAndPlantingLegend.css';
import { processIntervals } from '../../../utils/processUnits';
import { usernameSelector, userSelector } from '../../../selectors/userSelectors';

const LAYER = IN_SEASON.APPLICATIONS;

export class ApplicationLegend extends Component {
  UNSAFE_componentWillMount() {
    const {
      username,
      fieldUuid,
      dates,
      crop,
      season,
      intervals,
      reqLegend: reqLegendProp,
      user,
    } = this.props;
    if (!intervals.length) {
      const subLayer = `${dates.endDate}_${crop}`;
      reqLegendProp(username, fieldUuid, dates, crop, LAYER, season, subLayer, user.uuid);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      crop: currentCrop,
      dates: currentDates,
      season: currentSeason,
      reqLegend: reqLegendProp,
      user
    } = this.props;
    const { username, fieldUuid, dates, crop, season, intervals } = nextProps;
    if (
      !intervals.length &&
      (currentCrop !== crop ||
        currentDates.endDate !== dates.endDate ||
        currentSeason !== season)
    ) {
      const subLayer = `${dates.endDate}_${crop}`;
      reqLegendProp(username, fieldUuid, dates, crop, LAYER, season, subLayer, user.uuid);
    }
  }

  toggleEditLegend = () => {
    const {
      index,
      trackAnalyticsEvent,
      intervals,
      toggleEditLegend: toggleEditLegendProp,
    } = this.props;
    toggleEditLegendProp(index);

    trackAnalyticsEvent('edit_legend', 'clicked', {
      numberOfSteps: intervals.length,
      min: intervals[0] && intervals[0].value,
      max:
        intervals[intervals.length - 1] &&
        intervals[intervals.length - 1].value,
    });
  };

  render() {
    const {
      currentUserHasFetched,
      intervals,
      locale,
      testId,
      units,
      unitsLocaleGroup,
      dates,
      crop,
      index,
      isFetching,
    } = this.props;

    const subLayer = `${dates.endDate}_${crop}`;

    if (!currentUserHasFetched || !intervals.length) {
      return <LegendItem isFetching />;
    }

    const finalIntervals = processIntervals(intervals, units, locale);
    return (
      <div
        className={styles.legendContainer}
        data-test-id={`${testId}-inSeason-${LAYER}`}
      >
        <EditLegendContainer
          crop={crop}
          dates={dates}
          index={index}
          intervals={finalIntervals.intervals}
          subLayer={subLayer}
          units={finalIntervals}
          unitsLocaleGroup={unitsLocaleGroup}
          year={dates.year}
        />
        <LegendItem
          intervals={finalIntervals.intervals}
          isEditable={Boolean(finalIntervals.key)}
          isFetching={isFetching}
          toggleEditLegend={this.toggleEditLegend}
          units={finalIntervals.key}
        />
      </div>
    );
  }
}

ApplicationLegend.propTypes = {
  crop: PropTypes.string.isRequired,
  currentUserHasFetched: PropTypes.bool.isRequired,
  dates: PropTypes.object.isRequired,
  fieldUuid: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  intervals: PropTypes.array,
  isFetching: PropTypes.bool,
  locale: PropTypes.string,
  reqLegend: PropTypes.func,
  season: PropTypes.string.isRequired,
  testId: PropTypes.string,
  toggleEditLegend: PropTypes.func,
  trackAnalyticsEvent: PropTypes.func.isRequired,
  units: PropTypes.object,
  unitsLocaleGroup: PropTypes.string,
  username: PropTypes.string,
  user: PropTypes.object,
};

ApplicationLegend.defaultProps = {
  intervals: [],
};

function mapStateToProps(state, props) {
  const activeSeason = state.seasons.activeSeasons[props.index];
  const { liquidData } = state.seasons.list[activeSeason.id];
  const liquidLayer = state.layers.list[activeSeason.id][LAYER];
  const activeSubLayerId = liquidLayer.activeSubLayerIds[props.index];
  const splitIndex = activeSubLayerId.indexOf('_');
  const activeEndDate = parseInt(activeSubLayerId.slice(0, splitIndex), 10);
  const activeCrop = activeSubLayerId.slice(splitIndex + 1);
  const { crop, liquidEndDate, liquidStartDate, liquidYear } = liquidData.find(
    (application) =>
      application.crop === activeCrop &&
      application.liquidEndDate === activeEndDate
  );
  const dates = {
    endDate: liquidEndDate,
    startDate: liquidStartDate,
    year: liquidYear,
  };

  const subLayer = `${liquidEndDate}_${crop}`;
  const { legend, localeGroup } = liquidLayer.subLayers[subLayer] || {};
  const units = getLayerUnits(LAYER, localeGroup);

  return {
    crop,
    currentUserHasFetched: state.currentUser.hasFetched,
    dates,
    email: state.user.email,
    fieldUuid: state.field.uuid.toUpperCase(),
    intervals: legend,
    isFetching: state.legend.isFetching,
    LAYER: IN_SEASON.APPLICATIONS,
    season: activeSeason.id,
    units,
    unitsLocaleGroup: localeGroup,
    username: usernameSelector(state),
    user: userSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      reqLegend,
      toggleEditLegend,
      trackAnalyticsEvent: trackEvent,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationLegend);
